export const parseEligibleProductsList = (eligibleProductsList) => {
  return eligibleProductsList.reduce((eligibleProducts, { productId, features }) => {
    eligibleProducts[productId] = { features };
    return eligibleProducts;
  }, {});
};

export const parseProductFeatures = ({ fieldId, features }) => {
  const parsedProductFeatures = {
    fieldUuid: fieldId,
    features: features.reduce((featuresByName, feature) => {
      featuresByName[feature] = true;
      return featuresByName;
    } , {})
  };

  return parsedProductFeatures;
};
